module.exports = {"450221100":"拉堡镇","450221101":"里雍镇","450221102":"百朋镇","450221103":"成团镇","450221104":"洛满镇","450221105":"流山镇","450221106":"三都镇","450221107":"里高镇","450221108":"进德镇","450221109":"穿山镇","450221110":"土博镇","450221111":"白沙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450221.json
// module id = 2213
// module chunks = 0